const en = ['Jan', 'Feb', 'Mar', 'Mar', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const todaysDate = new Date();

const formatTime = d => `${`0${d.getHours()}`.slice(-2)}:${`0${d.getMinutes()}`.slice(-2)}`;
const formatDays = d => `${`0${d.getDate()}`.slice(-2)}`;

export function formatDate(date, type, lang) {
  let res = '';
  if (date) {
    const isCn = lang === 'cn';
    date = new Date(date);
    const time = formatTime(date);
    const day = formatDays(date);
    const isToday = todaysDate.setHours(0, 0, 0, 0) === date.setHours(0, 0, 0, 0);

    const year = date.getFullYear();
    const month = date.getMonth();
    let text = '';
    let text2 = '';
    switch (type) {
      case 'y':
        text = isCn ? year : `${en[month]} ${day}`;
        text2 = isCn ? '今天' : 'Today';
        res = isToday ? text2 : text;
        break;
      case 'm':
        text = isCn ? `${month + 1}-${day}` : year;
        res = isToday ? time : text;
        break;
      default:
        res = '';
        break;
    }
  }

  return res;
}

export default {};
